import e from "react";
import { translate as r } from "@aws-amplify/ui";
import { Button as t } from "../../../primitives/Button/Button.js";
import { Flex as o } from "../../../primitives/Flex/Flex.js";
import { View as n } from "../../../primitives/View/View.js";
import { FederatedSignIn as i } from "../FederatedSignIn/FederatedSignIn.js";
import { useAuthenticator as m } from "@aws-amplify/ui-react-core";
import { useCustomComponents as a } from "../hooks/useCustomComponents/index.js";
import { useFormHandlers as l } from "../hooks/useFormHandlers/useFormHandlers.js";
import { RemoteErrorMessage as s } from "../shared/RemoteErrorMessage.js";
import { FormFields as u } from "../shared/FormFields.js";
function d() {
  const {
      hasValidationErrors: u,
      isPending: c
    } = m(e => [e.hasValidationErrors, e.isPending]),
    {
      handleChange: p,
      handleBlur: f,
      handleSubmit: F
    } = l(),
    {
      components: {
        SignUp: {
          Header: h = d.Header,
          FormFields: E = d.FormFields,
          Footer: g = d.Footer
        }
      }
    } = a();
  return e.createElement(n, null, e.createElement(h, null), e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-signup": "",
    method: "post",
    onChange: p,
    onSubmit: F,
    onBlur: f
  }, e.createElement(i, null), e.createElement(o, {
    as: "fieldset",
    direction: "column",
    isDisabled: c
  }, e.createElement(o, {
    direction: "column"
  }, e.createElement(E, null), e.createElement(s, null)), e.createElement(t, {
    isDisabled: u || c,
    isFullWidth: !0,
    type: "submit",
    variation: "primary",
    isLoading: c,
    loadingText: r("Creating Account")
  }, r("Create Account")))), e.createElement(g, null));
}
d.Header = function () {
  return null;
}, d.FormFields = function () {
  return e.createElement(u, null);
}, d.Footer = function () {
  return null;
};
export { d as SignUp };